__turbopack_context__.v({
  "container": "KD97rq_container",
  "logo": "KD97rq_logo",
  "text": "KD97rq_text",
});
